import React from "react";
interface SectionHeadingProps {
  title: string;
  intro?: string;
  tone?: "dark" | "light";
}
export function SectionHeading({
  title,
  intro,
  tone = "dark"
}: SectionHeadingProps) {
  return <div className="grid items-end gap-6 md:grid-cols-[1fr_minmax(0,380px)]" data-id="element-636" data-mp="7fnuh7i8ciyj">
      <h2 className="font-display text-[clamp(3.5rem,10vw,9rem)] uppercase leading-[0.88] tracking-tight" data-id="element-637" data-mp="ce8nalv5k0cy">{title}</h2>
      {intro && <p className={`pb-3 text-[15px] font-medium leading-relaxed ${tone === "light" ? "text-cream/75" : "text-ink/75"}`} data-id="element-638" data-mp="104uukaxc1glw">
          {intro}
        </p>}
    </div>;
}